<!-- <div class="container-fluid">
    <div class="row">
        <h5> I-129-Efiling</h5>
        <h6>Steps for I-129 E-filing</h6>
    </div>
    <div class="row">
        <ol>
            <li>You need to first download the e-File Support Application. This is a one-time activity.</li>
            <li>To download the e-File Support Application (if not already installed), click Download Installer.</li>
            <li>To start transmitting data, click Launch. This will fetch I-129 e-filing details and launch the USCIS portal.</li>
            <li>Enter your credentials on USCIS manually to start the e-filing process on the USCIS portal.</li>
            <li>Follow instructions on screen, click Start I-129. This starts automatically populating all I-129 data step-by-step until Review and Submit. You need to manually review all the populated data and click Submit for final submission of the I-129.</li>
            <li>Repeat steps 3 to 5 to submit G-28 (attorney representation) and I-907 (premium processing)</li>
        </ol>
    </div>

    <div class="row">
        <div class="col-md-2">
            <button type="button" [disabled]="disableBtn" class="btn btn-primary" (click)="performAction()"> Download Installer</button>
          

        </div>
        
    </div>


</div>
<p-dialog key="selectOs" appendTo="body" class="download" header="Download E-File Tracker Application" #os [(visible)]="showDownloadInstaller" [style]="{width: '50vw'}">    
    <ng-template pTemplate="content">
     <div class="row">
      <div class="col">
         <label>Please select <strong>Download Now</strong>, if you do not have the efile tracker application installed.</label>          
      </div>
     </div>
     <div class="row">
      <div class="col-12">
         <label>Please select installed OS in your machine</label>
      </div>
      <div class="col-12">
         <p-radioButton class="mr-2" name="os" label="Mac / Linux" value="unix" [(ngModel)]="selectedOS"></p-radioButton>
          <p-radioButton name="os" label="Windows" value="windows" [(ngModel)]="selectedOS"></p-radioButton>
      </div>
     </div>    
    </ng-template>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="Cancel" (click)="closeDialog()"></button>
        <button type="button" pButton icon="pi pi-check" label="Download Now" (click)="performDownload()"></button>
    </ng-template>
</p-dialog> -->

<div class="fluid-container">
  <div class="row pt-4 d-flex align-items-center">
    <div class="col-md-9 step-title">
      <h5 class="mb-0">I-130-Efiling</h5>
      <p class="mb-0" style="font-size:14px">Steps for I-130 E-filing</p>
    </div>
    <div class="col-md-2 editBtn">
      <lib-step-status-update-component-library [visaType]="primaryData.caseType" [stepDetails]="stepDetails"
        type="EDIT" [isViewMode]="primaryData['isViewMode']" [isCaseRequest]="primaryData['isCaseRequest']">
      </lib-step-status-update-component-library>
    </div>
    <div class="col-md-1">
      <span (click)="handleClose();" class="close-icon pi pi-times pull-right"></span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 p-0">
      <lib-assigning-task-library [visaType]="primaryData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)" [isViewMode]="primaryData['isViewMode']"
        [isCaseRequest]="primaryData['isCaseRequest']">
      </lib-assigning-task-library>
    </div>
  </div>
  <p-divider class="header-divider"></p-divider>
  <lib-last-update-library [inputDetails]="stepDetails" [primaryData]="primaryData" [sectionCode]="sectionCode">
  </lib-last-update-library>
  <p-divider></p-divider>
  <!-- pending UI verification -->
  <div class="row">
    <ol class="instructions-align">
      <li>You need to first download the e-File Support Application. This is a one-time activity.</li>
      <li>To download the e-File Support Application (if not already installed), click Download Installer.</li>
      <li>To start transmitting data, click Launch. This will fetch I-130 e-filing details and launch the USCIS portal.
      </li>
      <li>Enter your credentials on USCIS manually to start the e-filing process on the USCIS portal.</li>
      <li>Follow instructions on screen, click Start I-130. This starts automatically populating all I-130 data
        step-by-step until Review and Submit. You need to manually review all the populated data and click Submit for
        final submission of the I-130.</li>
      <li>Repeat steps 3 to 5 to submit G-28 (attorney representation).</li>
    </ol>
  </div>
  <div class="row ml-4 mb-3" *ngIf="efilingVersionData?.latestVersion">
    {{efilingVersionData?.name}} latest version is <b>&nbsp;&nbsp;{{efilingVersionData?.latestVersion}}&nbsp;&nbsp; </b>
    and released date <b>&nbsp;&nbsp;{{efilingVersionData?.releaseDate}}&nbsp;&nbsp;</b>.
  </div>

  <div class="row">
    <div class="col-md-2">
      <button type="button" [disabled]="disabledControls" class="btn btn-primary" (click)="performAction()"> Download
        Installer</button>
    </div>
    <div class="col-md-2">
      <button type="button" [disabled]="disabledControls" class="btn btn-primary"
        (click)="performLaunch()">Launch</button>
    </div>
  </div>
  <div class="row pt-3 mt-n3">
    <lib-custom-questionnaire [stepId]="primaryData.stepId" [taskId]="primaryData.taskId" [viewQuestions]="false"
      [showSaveBtn]="false" [loadedIn]="stepDetails.stepName" [isSection]="false"></lib-custom-questionnaire>
  </div>
  <p-divider type="dashed" class="d-block"></p-divider>
  <div class="row py-3">
    <!-- <div class="col-md-2">
          <button pButton type="submit" label="Save" title="Save" class="save-btn" icon="pi pi-save"
            [ngClass]="enterProcessingInformationForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
            [disabled]="enterProcessingInformationForm.invalid  || disabledControls"></button>
        </div>
        <div class="col-md-2">
          <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left
              d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleCancel()">
          </button>
        </div> -->
    <div class="col-md-2"></div>
    <div class="col-md-6 completeStep">
      <lib-step-status-update-component-library [visaType]="primaryData.caseType" [stepDetails]="stepDetails"
        [type]="typeOfButton"></lib-step-status-update-component-library>
    </div>
  </div>
</div>
<p-dialog key="selectOs" appendTo="body" class="download" header="Download E-File Tracker Application" #os
  [(visible)]="showDownloadInstaller" [style]="{width: '50vw'}">
  <ng-template pTemplate="content">
    <div class="row">
      <div class="col">
        <label>Please select <strong>Download Now</strong>, if you do not have the efile tracker application
          installed.</label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Please select installed OS in your machine</label>
      </div>
      <div class="col-12">
        <p-radioButton class="mr-2" name="os" label="Mac / Linux" value="unix" [(ngModel)]="selectedOS"></p-radioButton>
        <p-radioButton name="os" label="Windows" value="windows" [(ngModel)]="selectedOS"></p-radioButton>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Cancel" (click)="closeDialog()"></button>
    <button type="button" pButton icon="pi pi-check" label="Download Now" (click)="performDownload()"></button>
  </ng-template>
</p-dialog>